import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {Route,Routes,useLocation,Link,NavLink} from 'react-router-dom';
import {Login, Home, ForgotPassword, ResetPassword} from './pages';
import {Year,Quarter,Models,Goals} from './pages/manage';
import {Roundup_Prepare,Roundup_Underway} from './pages/roundup';
import {ErrorNotFound} from './pages/error';
import {My_Account, Backups} from './pages/account';
import { useUser } from './context/UserContext';
import accountIcon from './images/account-icon.png';
import hammerTheBacklogLogo from './images/hammer-the-backlog.png';

function App(){

  //***********//
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [activeYearStartDate, setActiveYearStartDate] = useState(null)
  const { setUser } = useUser()

  useEffect(() => {
    const verifyCookie = async() => {
      const publicRoutes = ['/login', '/forgot-password', '/reset-password']

      try {
        const {data} = await axios.post(
          `${process.env.REACT_APP_WEB_URL}`,
          {},
          {withCredentials:true}
        )
        const {status, user_id, authProvider, theme}=data

        if (status) {
          setIsLoggedIn(true)
          setUser({ user_id, authProvider, theme: theme || 'default' })
          document.documentElement.setAttribute('data-theme', theme || 'default')
          // Redirect authenticated users away from public routes
          if (publicRoutes.includes(location.pathname)) {
            navigate('/')
          }
        } else {
          setIsLoggedIn(false)
          if (!publicRoutes.includes(location.pathname)) {
            navigate('/login')
          }
        }
      } catch (error) {
        setIsLoggedIn(false)
        if (!publicRoutes.includes(location.pathname)) {
          navigate('/login')
        }
      }
    }
    verifyCookie()
  }, [location.pathname,navigate])

  // Fetch active year to determine roundup turnover day
  useEffect(() => {
    const fetchActiveYear = async () => {
      if (!isLoggedIn) return
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_WEB_URL}api/year/get-current-active-year`,
          {},
          { withCredentials: true }
        )
        if (data && data.length > 0) {
          // Use the year with the soonest end date
          const sorted = [...data].sort((a, b) => new Date(a.endDate) - new Date(b.endDate))
          setActiveYearStartDate(sorted[0].startDate)
        }
      } catch (error) {
        console.log('Unable to fetch active year for roundup date:', error)
      }
    }
    fetchActiveYear()
  }, [isLoggedIn])

  function findNextRoundupDate() {
    if (!activeYearStartDate) {
      // No active year — fall back to Sunday-based calculation
      let daysUntilSunday = 7 - new Date().getDay()
      if (daysUntilSunday === 7) return "Today!"
      let date = new Date()
      date.setDate(date.getDate() + daysUntilSunday)
      return date.toDateString()
    }

    // The roundup week turns over on the same day of the week
    // the year started on. E.g. year started on a Wednesday →
    // roundups turn over every Wednesday.
    const turnoverDay = new Date(activeYearStartDate).getDay() // 0=Sun … 6=Sat
    const today = new Date()
    const todayDay = today.getDay()

    let daysUntilTurnover = (turnoverDay - todayDay + 7) % 7
    // If daysUntilTurnover is 0, today IS the turnover day
    if (daysUntilTurnover === 0) return "Today!"

    let nextDate = new Date(today)
    nextDate.setDate(today.getDate() + daysUntilTurnover)
    return nextDate.toDateString()
  }
  const Logout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_WEB_URL}logout`, {}, {withCredentials:true})
    } catch (e) {
      // Even if the call fails, proceed with redirect
    }
    setIsLoggedIn(false)
    window.location.replace(`${process.env.REACT_APP_WEB_URL}`);
  }

  function Header({logged_in}) {
    if(logged_in) {
      return (
        <div className="header">
          <div className="row space-between">
            <div className="col">
              <p>Current Date: {new Date().toDateString()}</p>
              <p>Next Roundup: {findNextRoundupDate()}</p>
            </div>
            <div className="col quick-header-navigation">
              <NavLink className="tab" activeClassName="active" to="/prepare-weekly-roundup">Weekly Roundup</NavLink>
              <NavLink className="tab" activeClassName="active" to="/manage-goals">Your Goals</NavLink>
              <NavLink className="tab" activeClassName="active" to="/manage-year">Your Year</NavLink>
              <NavLink className="tab" activeClassName="active" to="/manage-models">Your Models</NavLink>
            </div>
            <div className="col row">
              <div id="account-menu">
                <img src={accountIcon} alt="Acccount" />
                <div id="account-submenu">
                  <Link to="/">Back to home</Link>
                  <Link to="/my-account">My account</Link>
                  <Link to="/backups">Backups</Link>
                  <Link to="/" onClick={Logout}>Log out</Link>
                </div>
              </div>
              <Link to="/"><img src={hammerTheBacklogLogo} alt="Hammer The Backlog" /></Link>
            </div>
          </div>
        </div>
      )
    }

    return false
  }

  let appCurrentPathname = location.pathname == '/' ? 'home' : (location.pathname).substring(1)

  return(
    <>
      <div className="App" id={appCurrentPathname + '-app-wrap'}>
        <Header logged_in={isLoggedIn} />
        <div className="body">
          <div className="row">
            <Routes>
              <Route path="*" element={<ErrorNotFound />} />
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/manage-year" element={<Year />} />
              <Route path="/manage-quarter" element={<Quarter />} />
              <Route path="/manage-models" element={<Models />} />
              <Route path="/manage-goals" element={<Goals />} />
              <Route path="/prepare-weekly-roundup" element={<Roundup_Prepare />} />
              <Route path="/weekly-roundup-underway" element={<Roundup_Underway />} />
              <Route path="/my-account" element={<My_Account />} />
              <Route path="/backups" element={<Backups />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;